import request from "@/router/axios";

// 查看公司类型详情
export const deptManageNoteDetail = (deptId) => {
  return request({
    url: `/api/deptManageNote/detail`,
    method: "get",
    params:{
      deptId
    }
  });
}

// 设置公司类型
export const updateDeptType = (data) => {
  return request({
    url: `/api/blade-system/dept/updateDeptType`,
    method: "post",
    data:{
      ...data
    }
  });
}
